import { yupResolver } from '@hookform/resolvers/yup';
import { useMemo } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { BedroomsQuery } from '../../../../../apollo/__generated__/graphql';
import { useAddBedroomToPlaceMutation } from '../../../../hooks/useAddBedroomToPlaceMutation';
import { BedroomFormInputs } from '../BedroomForm/BedroomForm';

const schema = yup
  .object({
    floor: yup.number().required("L'étage est requis"),
    doorNumber: yup.string().required('Le numéro de la chambre est requis'),
    maxUsers: yup.number().required('Le nombre de places est requis'),
  })
  .required();

export const useCreateBedroomDrawer = (
  placeId: string | null,
  onClose: () => void,
  otherBedrooms: BedroomsQuery['bedrooms'],
) => {
  const { addBedroomToPlace } = useAddBedroomToPlaceMutation(() => {
    onClose();
  });

  const defaultValues = useMemo(() => {
    if (otherBedrooms.length === 0) {
      return {
        floor: 1,
        doorNumber: '11',
        maxUsers: 5,
      };
    }
    const lastBedroom = otherBedrooms[otherBedrooms.length - 1];

    return {
      floor: lastBedroom.floor,
      doorNumber: lastBedroom.doorNumber,
      maxUsers: lastBedroom.maxUsers,
    };
  }, [otherBedrooms]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<BedroomFormInputs>({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const onValid: SubmitHandler<BedroomFormInputs> = async (data) => {
    if (!placeId) {
      return;
    }
    addBedroomToPlace({
      ...data,
      placeId,
    });
  };

  const onSubmit = handleSubmit(onValid);

  return {
    onSubmit,
    register,
    errors,
  };
};
